import {Component} from '@angular/core';

@Component({
  selector: 'app-user-location-marker',
  templateUrl: './user-location-marker.component.html'
})
export class UserLocationMarkerComponent {}
